export default __webpack_public_path__ + "static/media/41.1ded13c2.png";